(function () {
  const contactForm = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const reason = urlParams.get("reason");
    const orderName = urlParams.get("order_name");

    // 필요하면 폼 필드에 값 자동 입력
    const reasonInput = document.querySelector('[name="reason"]');
    const orderNameInput = document.getElementById("ContactForm-orderName");
    const orderNameInputHidden = document.querySelector(
      '[name="contact[OrderName]"]'
    );
    const returnReasonSelect = document.getElementById(
      "ContactForm-Return-Reason"
    );
    const returnReasonWrap = document.getElementById(
      "contact-return-reason-wrap"
    );

    if (reasonInput) reasonInput.value = reason || "";
    if (orderNameInput) orderNameInput.value = `#${orderName}` || "";
    if (orderNameInputHidden)
      orderNameInputHidden.value = `#${orderName}` || "";
    // 파라미터 값이 존재하면 email-form-wrap에서 클래스 제외
    const emailFormWrap = document.getElementById("email-form-wrap");
    const orderNameFormWrap = document.getElementById("order_name_wrap");

    const subjectSelectForm = document.getElementById("ContactForm-subject");
    const subjectSelectFormHidden = document.getElementById(
      "ContactForm-subject-hidden"
    );

    const contactFormBody = document.getElementById("ContactForm-body");

    if (emailFormWrap && (reason || orderName)) {
      emailFormWrap.classList.remove("c-input--full");
      orderNameFormWrap.classList.remove("visually-hidden");
      subjectSelectForm.setAttribute("disabled", "true");
    }

    if (subjectSelectForm && subjectSelectFormHidden) {
      if (reason === "cancel") {
        subjectSelectForm.value = "Cancel Request";
        subjectSelectFormHidden.value = "Cancel Request";
        returnReasonSelect.removeAttribute("required");
        contactFormBody.removeAttribute("required");
        const label = document.querySelector('label[for="ContactForm-body"]');
        if (label) {
          label.innerHTML = label.innerHTML.replace("*", "");
        }
        returnReasonSelect.setAttribute("disabled", "true");
      } else if (reason === "return") {
        subjectSelectForm.value = "Return Request";
        subjectSelectFormHidden.value = "Return Request";
        returnReasonWrap.classList.remove("visually-hidden");
      } else {
        subjectSelectFormHidden.setAttribute("disabled", "true");
        orderNameInputHidden.setAttribute("disabled", "true");
        returnReasonSelect.removeAttribute("required");
        returnReasonSelect.setAttribute("disabled", "true");
        const cancelOption = subjectSelectForm.querySelector(
          'option[value="Cancel Request"]'
        );

        const returnOption = subjectSelectForm.querySelector(
          'option[value="Return Request"]'
        );
        cancelOption.style.display = "none";
        returnOption.style.display = "none";
      }
    }
  };

  document.addEventListener("DOMContentLoaded", function () {
    contactForm();
  });
})();
